import getEnvironDomain from 'ati-utils/getEnvironDomain';

import { queryString, fromQueryString } from 'as-ui-kit/utils/urls';
import { wialonTokenRegex } from 'as-ui-kit/const/sensors';
const domain = getEnvironDomain();

export function openWindow(url, parameters = {}, center = true) {
    const currentWindowHeaderHeight = window.outerHeight - window.innerHeight;
    const headerHeight = currentWindowHeaderHeight > 57 ? currentWindowHeaderHeight : 57;

    if (parameters.width && parameters.width > screen.availWidth) {
        parameters.width = screen.availWidth;
    }
    if (parameters.height && parameters.height + headerHeight > screen.availHeight) {
        parameters.height = screen.availHeight - headerHeight;
    }

    if (center && parameters.height) {
        parameters.top = (screen.availHeight - parameters.height) / 2 + window.screenY;
    }

    if (center && parameters.width) {
        parameters.left = (screen.availWidth - parameters.width) / 2 + window.screenX;
    }

    const parametersString = Object.keys(parameters)
        .map(key => `${key}=${parameters[key]}`)
        .join(',');
    const newWindow = window.open(url, '_blank', parametersString);

    try {
        if (newWindow.outerHeight > screen.availHeight) {
            newWindow.resizeTo(newWindow.outerWidth, screen.availHeight);
        }
    } catch (error) {
        //ignore
    }

    return newWindow;
}

export const asyncOpenWindow =
    promise =>
        (parameters = {}, center = true) => {
            const newWindow = openWindow('about:blank', parameters, center);

            const handleOnload = () => {
                newWindow.document.body.innerHTML =
                    `<img src="https://files.${domain}/assets/shared/img/spinner-static.gif" />`;
                newWindow.document.body.style =
                'display: flex; align-items: center; justify-content: center; height: 100%;';
            };

            handleOnload();
            newWindow.addEventListener('load', handleOnload);
            promise
                .then(req => {
                    newWindow.removeEventListener('load', handleOnload);

                    newWindow.location.href = req.url;

                    return req;
                })
                .catch(error => {
                    newWindow.close();
                    throw error;
                });

            return promise;
        };

export function openWindowWithPost(url, params, name) {
    const form = document.createElement('form');
    form.setAttribute('accept-charset', 'post');
    form.setAttribute('method', 'post');
    form.setAttribute('action', url);
    form.setAttribute('target', name);

    for (let i in params) {
        if (params[i] == null) {
            continue;
        }
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}

/**
 * @callback onSaveCallback
 * @param {number} lat - Широта
 * @param {number} lon - Долгота
 * @param {string} address - Адрес
 * @returns {void}
 */
/**
 * Открывает карту как в форме добавления грузов. При сохранении вызывает `onSave`
 * с широтой, долготой и адресом. При указании координат, карта будет открыта
 * с пином в указанном месте.
 *
 * @see http://stash:7990/projects/AW/repos/ati.web/browse/WebSite/Trace/GeoPoint.aspx
 *
 * @param {string} loadsUrl URL грузов (loads.ati.staging-1, loads.ati.su...)
 * @param {Object} mapWindowParams - Параметры окна карты
 * @param {number} mapWindowParams.selectType 1 - загрузка, что угодно - разгрузка. От этого зависит заголовок окна с картой ("Укажите точку Загрузки/Разгрузки на карте")
 * @param {number} mapWindowParams.lat - Широта
 * @param {number} mapWindowParams.lon - Долгота
 * @param {string|number} mapWindowParams.cityId ID города
 * @param {onSaveCallback} onSave Коллбэк.
 */
export function openMapWindow(loadsUrl, mapWindowParams, onSave, origin, withoutCity) {
    function getFullReverseGeocodeResult(res) {
        const addressWithoutCity = res?.address?.Address;
        const parsedLat = parseFloat(res?.latlng?.lat);
        const parsedLon = parseFloat(res?.latlng?.lng);
        const city = res?.address?.City || res?.address?.District;

        if (withoutCity) {
            onSave(addressWithoutCity, parsedLat, parsedLon);
        } else {
            onSave(parsedLat, parsedLon, addressWithoutCity, city);
        }

        delete window.getFullReverseGeocodeResult;
    }

    window.getFullReverseGeocodeResult = getFullReverseGeocodeResult;

    const windowSettings = {
        width: 520,
        height: 600,
        left: (window.screen.width - 520) / 2,
        top: (window.screen.height - 600) / 2,
        scrollbars: 'yes',
        resizable: 'yes',
    };

    const params = {
        Action: mapWindowParams.selectType === 1 ? 'SelectLoad' : 'SelectUnload',
        CityID: mapWindowParams.cityId,
        Latitude: mapWindowParams.lat || '',
        Longitude: mapWindowParams.lon || '',
    };

    const mapUrl = `${loadsUrl}/Trace/GeoPoint.aspx?${queryString(params)}`;

    const popup = window.open(
        mapUrl,
        '',
        Object.keys(windowSettings)
            .map(key => `${key}=${windowSettings[key]}`)
            .join(',')
    );

    function processEventFromMapWindow(event) {
        if (!event) {
            return null;
        }

        const eventOrigin = new URL(event.origin).hostname;

        // В Firefox и Safari event.source и popup одинаковые объекты, а в Chrome они разные
        // Из-за этого в Firefox функция getFullReverseGeocodeResult(event.data) вызывалась с невалидиными данными
        // Как вариант, можно проверять на popup.closed. То есть если попап открыт, то возвращаем null
        if (eventOrigin !== origin || event.source !== popup || !popup.closed) {
            return null;
        }

        getFullReverseGeocodeResult(event.data);
        window.removeEventListener('message', processEventFromMapWindow, false);
    }

    window.addEventListener('message', processEventFromMapWindow, false);

    popup.focus();
    return false;
}

export const getOpenWindowCallback = (url, cb) => () => {
    window.open(url);
    return cb?.();
};

/**
 * @callback onCreateSessionCallback
 * @param {string} host - wialon oAuth2 токен
 * @param {string} token - wialon хост
 * @returns {Promise} - результат создания сессии
 */
/**
 * Открывает форму логина Виалона. При успешном логине вызывает `onCreateSession`
 * с полученным токеном
 *
 * @see https://sdk.wialon.com/playground/demo/app_auth_token
 *
 * @param {onCreateSessionCallback} onCreateSession - коллбэк
 * @param {string} host - URL сервера, где развернут sdk Виалона
 * @param {string} locale - локаль пользователя (по дефолту 'ru')
 * @param {string} appName - название приложения-клиента (по дефолту ATI.SU)
 */
export function openWialonWindow(onCreateSession, host, authorizationHost, locale = 'ru', appName = 'ATI.SU') {
    function getWialonAuthResult(token, host) {
        onCreateSession({ host, token });

        delete window.getWialonAuthResult;
    }

    window.getWialonAuthResult = getWialonAuthResult;

    const windowSettings = {
        width: 685,
        height: 424,
        left: (window.screen.width - 685) / 2,
        top: (window.screen.height - 424) / 2,
        resizable: 'yes',
        scrollbars: 'yes',
    };

    const loginFormUrl = authorizationHost ?? 'https://hosting.wialon.com';

    const params = {
        client_id: appName, // your application name
        access_type: 0x100, // access level, 0x100 = "Online tracking only"
        activation_time: 0, // activation time, 0 = immediately; you can pass any UNIX time value
        duration: 8640000, // duration, 604800 = one week in seconds, 0 = not limited (or 100 days, not sure))
        flags: 0x1, // options, 0x1 = add username in response
        lang: locale,
        redirect_uri: loginFormUrl + '/post_token.html', // if login succeed - redirect to this page
    };

    let mapUrl = `${loginFormUrl}/login.html?${queryString(params)}`; // your site DNS + "/login.html"

    const popup = window.open(
        mapUrl,
        '',
        Object.keys(windowSettings)
            .map(key => `${key}=${windowSettings[key]}`)
            .join(',')
    );

    function processEventFromMapWindow(event) {
        if (!event || event.origin !== loginFormUrl || event.source !== popup || !event.data) {
            return null;
        }

        //валидируем data на случай, если нам пришлют не токен
        let resParams = fromQueryString(event.data);
        const pair = resParams.find(p => p && p.key === 'access_token');
        if (!pair || !wialonTokenRegex.exec(pair.value)) {
            return null;
        }

        getWialonAuthResult(pair.value, host);
        window.removeEventListener('message', processEventFromMapWindow, false);
    }
    window.addEventListener('message', processEventFromMapWindow, false);

    popup.focus();
    return false;
}
